export default {
    title: 'ANTE',
    appId: 'ANTE-ERP-User-Web',
    isUserApp: true,
    isAnte: true,
    login: {
        alignRight: false
    },
    theme: 'Ante-Blue',
    isLocal: process.env.REACT_APP_IS_LOCAL
};
